import { BASE_URL } from "@src/constants/apiEndpoints";

export const handleCostcoVerificationSSO = () => {
  localStorage.removeItem('costcoVerificationToken');
  const hostname = window.location.hostname;
  const trimmedHost = hostname.split('.').slice(0, -1).join('.');
  const url = `${BASE_URL}/api/v1/mvt/auth/sso?redirect=${trimmedHost}&page=VERIFICATION`;
  console.log('Redirecting to Costco VERIFICATION SSO:', url);
  window.location.href = url;
};